


























import {Component, Vue, Watch} from 'vue-property-decorator';
import {ISupplier} from '@/models/ISupplier';
import {IOrder} from '@/models/IOrder';
import {getListSuppliers} from '@/services/SupplierService';
import {exportOrderToSheet, getListOrders} from '@/services/OrderService';
import OrderSupplierSelectionTable from '@/screens/dashboard/orders/OrderSupplierSelectionTable.vue';
import {Confirm} from '@/decorators/ConfirmDialogDecorator';
import {LayoutModule, NotificationType} from '@/store/modules/LayoutModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

export interface IOrderSupplierSelection extends IOrder {
  supplier: ISupplier;
}

@Component({
  components: {
    OrderSupplierSelectionTable
  }
})
export default class OrderTrackingExportScreen extends Vue {
  loading: boolean = true;
  suppliers: ISupplier[] = [];
  orders: IOrderSupplierSelection[] = [];
  selectOrders: IOrderSupplierSelection[] = [];
  exporting: boolean = false;

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.suppliers = await getListSuppliers(this.organizationId, this.shopId);
      this.orders = (await getListOrders(this.organizationId, this.shopId)).map((order) => {
        let supplier = this.suppliers.find((sup) =>
            sup.products.some((product) => product.sp_product_id === order.line_items[0].product_id)
        );

        if (!supplier) {
          supplier = this.suppliers[0];
        }
        return {
          ...order,
          supplier
        };
      });
    } finally {
      this.loading = false;
    }
  }

  onItemToggle(item: IOrderSupplierSelection) {
    if (this.selectOrders.find((selectedOrder) => selectedOrder.id === item.id)) {
      this.selectOrders = this.selectOrders.filter((order) => order.id !== item.id);
    } else {
      this.selectOrders = [...this.selectOrders, item];
    }
  }

  get canExport() {
    return this.selectOrders.length > 0;
  }

  @Confirm('Confirmation', 'Are you sure to export?')
  async exportOrders() {
    try {
      this.exporting = true;
      const orders = this.selectOrders.map((order) => ({
        id: order.id,
        supplier: order.supplier.id
      }));
      const result = await exportOrderToSheet(this.organizationId, this.shopId, orders);
      if (result) {
        LayoutModule.showNotification({text: 'Export successfully!'});
        this.$router.back();
      } else {
        LayoutModule.showNotification({text: 'Export error!', type: NotificationType.ERROR});
      }
    } finally {
      this.exporting = false;
    }

  }
}
